export default __webpack_public_path__ + "static/media/news_top.c73a276a.svg";